<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  field: any;
  rowData: any;
  settings: any;
}>();

const address = computed(() => {
  if (!props.field) return null;

  const rawAddress = props?.settings?.rawAddress;
  if (rawAddress) return props.field;

  return props.field[props.settings.render.targetKey];
});

const formattedAddress = computed(() => {
  if (!address.value) return null;
  if (typeof address.value !== 'object') return address.value;

  const address1 = address.value.address_1 || address.value.address1 || '';
  const address2 = address.value.address_2 || address.value.address2 || '';
  const city = address.value.city || '';
  const state = address.value.state || '';
  const zip = address.value.zip || '';
  const country = address.value.country || '';

  const firstLine = address1 + (address1 && address2 ? ', ' : '') + address2;
  const secondLine =
    ((state && city) || (zip && city) ? `${city}, ` : city) +
    (state && zip ? `${state}, ` : state) +
    zip +
    (country ? ` - ${country}` : '');

  const oneLine = `${firstLine}${firstLine && secondLine ? ' ' : ''}${secondLine}`.trim();
  return oneLine || null;
});
</script>

<template>
  <p v-if="!formattedAddress">-</p>

  <p
    v-else
    v-tooltip.top="formattedAddress"
    v-html="formattedAddress"
  ></p>
</template>
